export const GET_CONTACTS_FULL_LIST = 'GET_CONTACTS_FULL_LIST'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
